import Vue from "vue";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

//引入富文本css
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import App from "./App.vue";
import router from "./router";

import store from "./store";

Vue.config.productionTip = false;
Vue.use(ElementUI);

//消息弹窗封装引入
import messageUtils from "./utils/messageUtils";
Vue.prototype.$message = messageUtils;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
